import * as yup from 'yup';
import { nullableImageFromCMSSchema } from '@web/cms';

export const schema = yup
  .object({
    title: yup.string(),
    description: yup.string(),
    image: nullableImageFromCMSSchema,
    ctaText: yup.string(),
  })
  .transform(value =>
    value
      ? {
          title: value.title,
          description: value.description,
          image: value.image,
          ctaText: value.cta_text,
        }
      : undefined,
  );
